












































































import { Component, Prop, Watch } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import { mixins } from "vue-class-component";
import CompanyMixin from "@/mixins/CompanyMixin";
import { Chrome } from "vue-color";
import { IStudentCategory } from "@/interfaces/IStudentCategory";
import Validation from "@/components/Validation.vue";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";

@Component({
  components: {
    Validation,
    FscSimpleCard,
    SaveButton,
    AbortButton,
    "chrome-picker": Chrome,
  },
})
export default class StudentCategoriesForm extends mixins(CompanyMixin) {
  public name = "StudentCategoriesForm";

  @Prop()
  studentCategory!: any;

  @Prop({ type: Boolean, required: false, default: () => false })
  public isLoading!: boolean;

  private editMode = false;

  public category = {
    id: 0,
    name: "",
    abbreviation: "",
    textColorHex: "",
    backgroundColorHex: "",
    archived: false,
  };

  get backgroundColorObj() {
    return { hex: this.category.backgroundColorHex };
  }

  set backgroundColorObj(color: { hex: string }) {
    this.category.backgroundColorHex = color.hex;
  }

  get textColorObj() {
    return { hex: this.category.textColorHex };
  }

  set textColorObj(color: { hex: string }) {
    this.category.textColorHex = color.hex;
  }

  public toggleEditMode() {
    this.editMode = !this.editMode;
  }

  public mounted(): void {
    this.category = this.studentCategory;

    // Set default colors
    this.backgroundColorObj = { hex: this.category?.backgroundColorHex || "#2f2f2f" };
    this.textColorObj = { hex: this.category?.textColorHex || "#ffffff" };
  }

  public onAbort(): void {
    this.$emit("on-abort");
  }

  public onSubmit(): void {
    if (this.hasNotPermissionWrite) return;
    this.$v.$touch();
    if (this.$v.$invalid) return;

    const stdCategory = {
      name: this.category.name,
      abbreviation: this.category.abbreviation,
      textColorHex: this.category.textColorHex,
      backgroundColorHex: this.category.backgroundColorHex,
      archived: this.category.archived,
    };
    this.$emit("on-submit", stdCategory);
  }

  @Validations()
  public validations(): Record<string, any> {
    return {
      category: {
        name: { required },
        abbreviation: { required },
      },
    };
  }

  @Watch("studentCategory", { immediate: true, deep: true })
  public onStudentCategoryChange(studentCategory: IStudentCategory): void {
    if (studentCategory) {
      this.category = studentCategory;
    }
  }
}
